<template>
    <div class="flexbox" :class="positionClass" v-if="showPaging">
        <nav aria-label="Pagination">
            <ol class="list-pagination">
                <li class="list-pagination-button">
                    <button :disabled="isFirstPage" rel="prev" @click="previousPage()">Forrige</button>
                </li>
                <li class="list-pagination-items">side {{ activePage }} af {{ totalPages }}</li>
                <li class="list-pagination-item" v-for="page in pages">
                    <span v-if="page === '...'">{{ page }}</span>
                    <button v-else :disabled="isActivePage(page)" :aria-current="isActivePage(page) ? 'page' : null" @click="selectPage(page)">{{ page }}</button>
                </li>
                <li class="list-pagination-button">
                    <button :disabled="isLastPage" rel="next" @click="nextPage()">Næste</button>
                </li>
            </ol>
        </nav>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'pagination',
    props: {
        showPaging: {
            type: Boolean,
            default: true
        },
        totalPages: {
            type: [Number, String],
            default: 0
        },
        page: {
            type: String
        },
        pagePadding: {
            type: Number,
            default: 2
        },
        position: {
            type: String,
            default: 'left'
        }
    },
    data () {
        return {
            activePage: 1
        }
    },
    computed: {
        ...mapGetters({
            activePages: 'getActivePages'
        }),

        isFirstPage () {
            return this.activePages[this.page] === 1
        },
        isLastPage () {
            return this.activePages[this.page] === this.totalPages
        },
        positionClass () {
            if (this.position === 'left') {
                return 'flexbox-start'
            } else if (this.position === 'center') {
                return 'flexbox-center'
            } else if (this.position === 'right') {
                return 'flexbox-end'
            }

            return 'center'
        },
        pages () {
            const pages = []
            let low = Math.max(this.activePages[this.page] - this.pagePadding, 1)
            let high = Math.min(this.activePages[this.page] + this.pagePadding, this.totalPages)

            if (this.activePages[this.page] === 1) {
                high = Math.min(this.activePages[this.page] + (this.pagePadding + 2), this.totalPages)
            }
            this.activePage = this.activePages[this.page]
            if (this.activePages[this.page] === this.totalPages) {
                low = Math.max(this.activePages[this.page] - (this.pagePadding + 1), 1)
            }
            for (let i = 1; i <= this.totalPages; i++) {
                if (i === 1) {
                    pages.push(i)
                } else if (i !== 1 && i === low - 1) {
                    pages.push('...')
                } else if (i >= low && i <= high) {
                    pages.push(i)
                } else if (i !== this.totalPages && i === high + 1) {
                    pages.push('...')
                } else if (i === this.totalPages) {
                    pages.push(i)
                }
            }

            return pages
        }
    },
    methods: {
        ...mapActions({
            setActivePages: 'setActivePages',
            getQueryEnquiriesList: 'getQueryRequestList',
            getQueryTaskList: 'getQueryTaskList',
            getQueryRequisitionList: 'getQueryRequisitionList',
            getQueryRoutineList: 'getQueryRoutineList',
            getQueryTemplateList: 'getQueryTemplateList',
            getQueryTaskListFromEnquiry: 'getQueryTaskListFromEnquiry'
        }),

        isActivePage (number) {
            return this.activePages[this.page] === number
        },
        async selectPage (page) {
            if (this.activePages[this.page] !== page) {
                let filter = {
                    pageNumber: page
                }

                this.activePage = page
                this.setActivePages({
                    tab: this.page,
                    page: page
                })
                if (this.page === 'enquiries') {
                    await this.getQueryEnquiriesList(filter)
                }
                if (this.page === 'tasks') {
                    await this.getQueryTaskList(filter)
                }
                if (this.page === 'requisitions') {
                    await this.getQueryRequisitionList(filter)
                }
                if (this.page === 'routines') {
                    await this.getQueryRoutineList(filter)
                }
                if (this.page === 'templates') {
                    await this.getQueryTemplateList(filter)
                }
                if (this.page === 'tasksSimple') {
                    await this.getQueryTaskListFromEnquiry(filter)
                }
            }
        },
        previousPage () {
            this.selectPage(this.activePages[this.page] - 1)
        },
        nextPage () {
            this.selectPage(this.activePages[this.page] + 1)
        }
    },
    created () {
        if (this.page === 'tasksSimple') {
            this.setActivePages({
                tab: this.page,
                page: 1
            })
        }
        this.activePage = this.activePages[this.page]
    }
}
</script>

<style lang="scss">
@import '../../../scss/components/pagination';
</style>



// WEBPACK FOOTER //
// src/components/shared/pagination/pagination.vue